/*
 * Copyright (C) 2017 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that they will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */
import React, { Children, Component } from 'react';
import { themeable } from '@instructure/ui-themeable';
import { Children as ChildrenPropType } from '@instructure/ui-prop-types';
import { Pill } from '@instructure/ui-elements';
const styles = {
  componentId: 'WWGvl',
  template: function template(theme) {
    return "\n\n.root_E0bF{line-height:".concat(theme.lineHeight || 'inherit', ";list-style-type:none;margin:0;padding:0;text-align:inherit}\n\n[dir=ltr] .root_E0bF,[dir=rtl] .root_E0bF{text-align:inherit}\n\n.item_E0bF{display:inline-block;margin:").concat(theme.itemMargin || 'inherit', ";vertical-align:middle}");
  },
  'root': 'root_E0bF',
  'item': 'item_E0bF'
};
import theme from './theme.js';

class BadgeList extends Component {
  renderChildren() {
    return Children.map(this.props.children, child => {
      return React.createElement("li", {
        key: child.key,
        className: styles.item
      }, child);
    });
  }

  render() {
    return React.createElement("ul", {
      className: styles.root
    }, this.renderChildren());
  }

}

BadgeList.propTypes = {
  children: ChildrenPropType.oneOf([Pill])
};
export default themeable(theme, styles)(BadgeList);